export enum TypeEnum {
    Alert = 'alert',
    Info = 'info',
    Warning = 'warning',
    Megapush = 'megapush',
    Relational = 'relational',
    WhoUsesIt = 'who-uses-it',
    ChangeOffer = 'change-offer',
    ChangeMobile = 'change-mobile',
    Commercial = 'commercial',
}
